<template>
  <li class="nav-item dropdown notification-list">
    <a class="nav-link dropdown-toggle arrow-none waves-effect waves-light nav-user" data-toggle="dropdown"
       href="#" role="button"
       aria-haspopup="false" aria-expanded="false">
      <gravatar :email="user.email" alt="user" class="img-circle"></gravatar>
    </a>
    <div class="dropdown-menu dropdown-menu-right dropdown-arrow profile-dropdown " aria-labelledby="Preview">
      <!-- item-->
      <div class="dropdown-item noti-title">
        <h5 class="text-overflow">
          <small>{{ user.name }}</small>
        </h5>
      </div>

      <!--
      <a href="javascript:void(0);" class="dropdown-item notify-item">
        <i class="zmdi zmdi-account"></i> <span>Mon compte</span>
      </a>
      -->

      <a href="javascript:void(0);" @click="impersonate" class="dropdown-item notify-item">
        <i class="zmdi zmdi-accounts-alt"></i> <span>Autre compte</span>
      </a>

      <router-link to="/preferences" class="dropdown-item notify-item">
        <i class="zmdi zmdi-settings"></i> <span>Préférences</span>
      </router-link>

      <a class="dropdown-item notify-item" v-on:click="lock" style="cursor: pointer;">
        <i class="zmdi zmdi-lock-open"></i> <span>Verouiller session</span>
      </a>

      <router-link to="/session/logout" class="dropdown-item notify-item">
        <i class="zmdi zmdi-power"></i> <span>Déconnexion</span>
      </router-link>
    </div>
  </li>
</template>

<script>
  import gravatar from 'vue-gravatar'

  import { events } from '../../../../services/event-bus.js'

  export default {
    name: 'li-account',
    components: {
      gravatar
    },
    computed: {
      user () {
        return this.$store.getters['users/current']
      }
    },
    methods: {
      lock () {
        events.emit('app/ui/locked')
      },
      impersonate () {
        events.emit('app/ui/impersonate')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LiAccount.vue?3a3f555c